module.exports = __webpack_public_path__ + "img/avatar6.95aa1a33.png";